import dayjs from 'dayjs';

export const dayAgo = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
export const today = dayjs().format('YYYY-MM-DD');
export const lastFriday = dayjs().day(5).subtract(7, 'day').format('YYYY-MM-DD');
export const isSundayToday = dayjs().day() === 0;
export const isMondayToday = dayjs().day() === 1;
